import React from 'react';
import './MissionVision.css';
import { useEffect } from 'react';
function MissionVision() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []); 
  return (
    <div className="mv-container">
      <div className="mv-section">
        <h2 className="mv-heading">Our Vision</h2>
        <p className="mv-paragraphh">
          The vision of the Oxford Convent English Medium School is to provide
          opportunities to create Global citizens and leaders of tomorrow through
          traditional values of love, empathy, discipline, and respect and train
          the skills required for successful interaction with other individuals.
          We are and we will be a university where we design the good citizen
          and leaders.
        </p>
      </div>

      <div className="mv-section">
        <h2 className="mv-heading">Our Mission</h2>
        <ul className="mv-list">
          <li>Pursuit of excellence in academics, games and sports, co-curricular activities, and in human values.</li>
          <li>Development of personality, instilling qualities of self-reliance, courage, self-confidence, and self-esteem.</li>
          <li>Nurturing physically, mentally, spiritually balanced citizens with a deep sense of patriotism.</li>
          <li>Encouraging a desire for lifelong learning.</li>
          <li>Fostering independent thinking, thoughtful decision-making, critical analysis, appreciation with intellectual humility, to accept differences in opinion.</li>
          <li>Helping the students to discover what it is to live and grow with clarity of thought, with harmony in nature, with beauty and freedom in the world.</li>
          <li>Inculcating the best of Indian culture and tradition among the pupils. Creating responsible, disciplined, and secular citizens, who are fully aware of their social, moral, and cultural obligations and commitments, with a desire for unbounded service to humanity.</li>
        </ul>
      </div>
    </div>
  );
}

export default MissionVision;